import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';
import { ChevronRight } from 'lucide-react';

const Breadcrumbs = React.forwardRef(({ className, items, ...props }, ref) => {
  return (
    <nav
      ref={ref}
      aria-label="breadcrumbs"
      className={cn('flex items-center space-x-2 text-sm', className)}
      {...props}
    >
      {items.map((item, index) => (
        <React.Fragment key={item.href || index}>
          {index > 0 && (
            <ChevronRight className="h-4 w-4 text-gray-500" aria-hidden="true" />
          )}
          {item.href ? (
            <a
              href={item.href}
              className={cn(
                'text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100',
                index === items.length - 1 && 'font-medium text-gray-900 dark:text-gray-100'
              )}
            >
              {item.label}
            </a>
          ) : (
            <span
              className={cn(
                'text-gray-600 dark:text-gray-400',
                index === items.length - 1 && 'font-medium text-gray-900 dark:text-gray-100'
              )}
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
});

Breadcrumbs.displayName = 'Breadcrumbs';

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string
    })
  ).isRequired
};

export { Breadcrumbs }; 